/**
 * ABOUTME: Success view for SmartQuote showing confirmation and completion
 * ABOUTME: Displays a visual confirmation that quote request was sent successfully
 */
import React from 'react';
import { motion } from 'framer-motion';
import { ThumbsUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SmartQuoteSuccessViewProps {
  selectedTradespeople: string[];
  resetForm: () => void;
}

export function SmartQuoteSuccessView({
  selectedTradespeople,
  resetForm
}: SmartQuoteSuccessViewProps) {
  return (
    <motion.div
      key="success-state"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ type: "spring", stiffness: 400, damping: 35 }}
    >
      <div className="p-3 text-center">
        <motion.div
          className="w-12 h-12 bg-green-50 rounded-full mx-auto flex items-center justify-center mb-2"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.1, type: "spring", stiffness: 300, damping: 25 }}
        >
          <ThumbsUp className="h-6 w-6 text-green-500" />
        </motion.div>

        <h3 className="text-base font-medium text-gray-800 mb-1">
          Quote Request Sent
        </h3>

        <p className="text-xs text-gray-500 mb-3 max-w-xs mx-auto">
          Your message was sent to {selectedTradespeople.length} {selectedTradespeople.length === 1 ? 'tradesperson' : 'tradespeople'}.
          They'll be in touch with you soon.
        </p>

        <Button
          variant="outline"
          onClick={resetForm}
          className="rounded-full text-xs px-4 py-1 border-gray-200 text-purple-600 hover:bg-purple-50 hover:border-purple-200"
        >
          Send Another Request
        </Button>
      </div>
    </motion.div>
  );
}